import React from 'react'
import { Box, IcoMoon, Text, CancelIcon } from '@usap/uicomponents'

export default function InfoMessageBox({ type, message }) {
  const colorType = type === 'error' ? '#FF0000' : '#2e4787'
  const borderStyle = {
    borderBottom: `1px solid ${colorType}`,
    borderTop: `1px solid ${colorType}`,
    borderRight: `1px solid ${colorType}`,
    borderLeft: `7px solid ${colorType}`,
  }

  return (
    <Box pad="medium" style={borderStyle} direction="row" align="center" margin={{ bottom: '10px' }}>
      <Box>
        <IcoMoon
          style={{ marginRight: 10 }}
          icon={CancelIcon}
          size="36px"
          color={colorType}
        />
      </Box>
      <Box>
        <Text size="small" color="#333">
          {message}
        </Text>
      </Box>
    </Box>
  )
}
